import type { IxcInventoryV1TradingDayKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const INVENTORY_TRADING_DAY_BASE_PATH = getResolvedPath('/clearing/operations/inventory/trading-day');

export const getInventoryTradingDayPath: EntityPathBuilder<IxcInventoryV1TradingDayKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INVENTORY_TRADING_DAY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.assetId || !context?.keys?.date) {
        return undefined;
      }

      return getResolvedPath(`${INVENTORY_TRADING_DAY_BASE_PATH}/$assetId/$date`, context.keys);
    }
  }
};

export function getInventoryTradingDayDetailPath(assetId: string | undefined, date: string | undefined) {
  if (!assetId || !date) {
    return undefined;
  }

  return getInventoryTradingDayPath({ kind: 'detail', keys: { assetId, date } });
}
